import { ThemeProvider } from 'styled-components';

import { GlobalStyles } from './globalStyles';
import { theme } from './theme';

const styles = {
  GlobalStyles,
  ThemeProvider,
  theme,
};

export default styles;
